import React, { useRef } from 'react'
import { NavLink} from 'react-router-dom'
import './mainmenu.css';
import menuIcon from '../ui/icon_menu.svg'



const MainMenu = () => {


  const iconRef = useRef();
  const menuRef = useRef();

  // console.log(window.innerWidth);


  const handleOnClickMenu = () => {

    // var width = window.innerWidth;
    // console.log(width);


    if (window.innerWidth <= 768) {

      // console.log('window is ' + window.innerWidth);


      menuRef.current.style.display = 'none';
      iconRef.current.style.display = 'block';

    }

  }

  return (

    <>

      <div className='menuIcon' ref={iconRef} onClick={() => {


        iconRef.current.style.display = 'none';
        menuRef.current.style.display = 'block';
      }}>
        <img src={menuIcon} alt="" />

      </div>

      <div className='menu_Container' ref={menuRef}>


        <nav id="mainMenu">




          <ul>

            <div className='xIcon' onClick={handleOnClickMenu}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="white" />
              </svg>
            </div>

            

            <div>
              <li onClick={handleOnClickMenu}><NavLink to="">STARTSEITE</NavLink></li>

            </div>

            <div>
              <li onClick={handleOnClickMenu}><NavLink to="kaleidoskop">[k]KALEIDOSKOP</NavLink></li>
            </div>
            <div>
              <li onClick={handleOnClickMenu}><NavLink to="archive">ARCHIV</NavLink></li>

            </div>
            <div>
              <li onClick={handleOnClickMenu}><NavLink to="textbook">TEXTBUCH</NavLink></li>

            </div>


          </ul>

        </nav>

      </div>


    </>

  )
}

export default MainMenu